import React from "react";
import { formatDate } from "../../service/constants";

const ConditionTextDetails = ({ conditionDetailData }) => {
  return (
    <div className="info-container">
      {conditionDetailData.resource.category[0].text && (
        <div>
          <span className="label">Category - </span>
          {conditionDetailData.resource.category[0].text}
        </div>
      )}
      {conditionDetailData.resource.code.coding &&
        conditionDetailData.resource.code.text && (
          <div>
            <span className="label">Disease - </span>
            {conditionDetailData.resource.code.coding[0].display ||
              conditionDetailData.resource.code.text}
          </div>
        )}

      {!conditionDetailData.resource.code.coding &&
        conditionDetailData.resource.code.text && (
          <div>
            <span className="label">Disease - </span>
            {conditionDetailData.resource.code.text}
          </div>
        )}

      {conditionDetailData.resource.code.coding && (
        <div>
          <span className="label">Snomed -</span>
          {conditionDetailData.resource.code.coding[0].code || "No Snomed"}
        </div>
      )}
      {conditionDetailData.resource.recordedDate && (
        <div>
          <span className="label">Date - </span>
          {formatDate(conditionDetailData.resource.recordedDate)}
        </div>
      )}
    </div>
  );
};

export default ConditionTextDetails;
